import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { EditOutlined, PlusCircleOutlined, TruckOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Select, Row, Col } from 'antd';
import LazyLoadSelect, {} from "../../components/LazyLoadSelect";
import HasPermissions from "../../../../containers/HasPermissions";
import { CustomerContactType } from "./api/Representation";
import CustomerContactUpdateModal from "./CustomerContactUpdateModal";
import { isStringNotBlank } from "../../../../swzutils/TypeUtils";
const CustomerContactSelect = ({ customerId, disabled = false, customerContactType, allowClear = true, showCrudButtons = true, canChangeContactType, value, placeholder = "Select Customer Contact", onChange, onCustomerContactSelected }) => {
    const selectRef = useRef(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [editCustomerContact, setEditCustomerContact] = useState(undefined);
    const optionsRenderer = (contacts) => {
        return contacts.map((contact) => {
            const icon = contact.type === CustomerContactType.DRIVER ? _jsx(TruckOutlined, {}) : _jsx(UserOutlined, {});
            let label = isStringNotBlank(contact.lastName) ? `${contact.firstName} ${contact.lastName}` : contact.firstName;
            if (contact.emailAddress) {
                label += " - " + contact.emailAddress;
            }
            return _jsxs(Select.Option, { value: contact.id, filter: label, children: [icon, " ", label] }, contact.id);
        });
    };
    const onSelected = (contact) => {
        setEditCustomerContact(contact);
        onCustomerContactSelected && onCustomerContactSelected(contact);
        onChange && onChange(contact?.id);
    };
    const onAddButtonClicked = () => {
        setShowUpdateModal(true);
        setEditCustomerContact(undefined);
    };
    const onEditButtonClicked = () => {
        setShowUpdateModal(true);
    };
    const hideUpdateModal = () => {
        setShowUpdateModal(false);
    };
    const addOrUpdateContact = (contact) => {
        selectRef.current?.update(contact);
        setEditCustomerContact(contact);
        onCustomerContactSelected && onCustomerContactSelected(contact);
        onChange && onChange(contact.id);
    };
    const editDisabled = disabled || value == null;
    return (_jsxs(Row, { wrap: false, children: [_jsx(Col, { flex: "auto", children: _jsx(LazyLoadSelect, { style: { width: '100%' }, ref: selectRef, disabled: disabled, allowClear: allowClear, placeholder: placeholder, url: `/admin/v1/customers/${customerId}/contacts`, notFoundMessage: "No customer contacts found", searchKey: "nameLike", queryParams: {
                        enabled: true,
                        type: customerContactType
                    }, onChange: onChange, onSelected: onSelected, optionsRenderer: optionsRenderer, value: value }) }), showCrudButtons &&
                _jsx(HasPermissions, { permissions: ['admin:customerContact:update'], children: _jsx(Col, { flex: "51px", children: _jsx(Button, { htmlType: "button", disabled: editDisabled, style: { marginLeft: "5px" }, type: "default", onClick: onEditButtonClicked, children: _jsx(EditOutlined, {}) }) }) }), showCrudButtons &&
                _jsx(HasPermissions, { permissions: ['admin:customerContact:create'], children: _jsx(Col, { flex: "51px", children: _jsx(Button, { htmlType: "button", disabled: disabled, style: { marginLeft: "5px" }, type: "default", onClick: onAddButtonClicked, children: _jsx(PlusCircleOutlined, {}) }) }) }), showCrudButtons &&
                _jsx(CustomerContactUpdateModal, { open: showUpdateModal, customerId: customerId, canChangeContactType: canChangeContactType, defaultCustomerContactType: customerContactType, customerContact: editCustomerContact, onSave: contact => {
                        hideUpdateModal();
                        addOrUpdateContact(contact);
                    }, onCancel: hideUpdateModal })] }));
};
export default CustomerContactSelect;
